import {
    DEFAULT_QR_QUALITY,
    DEFAULT_QR_BORDER,
    DEFAULT_QR_SCALE,
    COLOR_BLACK,
    COLOR_WHITE,
    DEFAULT_ZLIB_COMPRESSION_LEVEL,
    DEFAULT_ECC_LEVEL,
    ZIP_HEADER,
    DEFAULT_ZIP_FILE_NAME,
    CLAIM_169_MAP,
} from '../shared/Constants';

let cbor: any;

// Debug: Check webpack public path before loading chunks
if (typeof window !== 'undefined') {
  const publicPath = (window as any).__webpack_public_path__;
  console.log('[convertToCbor] Webpack public path before import:', publicPath);
  if (!publicPath || publicPath === '/') {
    console.warn('[convertToCbor] WARNING: Webpack public path is not set correctly!');
    console.warn('[convertToCbor] Attempting to set from window.env...');
    const basePath = (window as any).env?.REACT_APP_BASE_PATH || '';
    if (basePath) {
      const normalized = basePath.startsWith('/') ? basePath : `/${basePath}`;
      const newPublicPath = normalized + '/';
      (window as any).__webpack_public_path__ = newPublicPath;
      if (typeof globalThis !== 'undefined') {
        (globalThis as any).__webpack_public_path__ = newPublicPath;
      }
      console.log('[convertToCbor] Set webpack public path to:', newPublicPath);
    }
  }
}

(async () => {
  console.log('[convertToCbor] Starting dynamic import of cbor-web...');
  console.log('[convertToCbor] Current webpack public path:', (window as any).__webpack_public_path__);
  try {
    cbor = await import('cbor-web');
    console.log('[convertToCbor] CBOR module loaded successfully:', cbor);
  } catch (error) {
    console.error('[convertToCbor] Error loading cbor-web:', error);
    throw error;
  }
})();

export async function getMappedData(jsonData: Record<string, any>): Promise<[string, string]> {
    const remappedData = new Map<number | string, any>();
    Object.keys(jsonData).forEach((key) => {
        const literalKey = CLAIM_169_MAP.get(key);
        if (literalKey) {
            remappedData.set(literalKey, jsonData[key]);
        } else {
            remappedData.set(key, jsonData[key]);
        }
    });
    // Ensure cbor is loaded dynamically
    if (!cbor) {
        cbor = await import('cbor-web');
    }
    return [mapToString(remappedData), cbor.encode(remappedData).toString('hex')];
}

function mapToString(map: Map<any, any>, indent = ''): string {
    let result = '{\n';
    const nextIndent = indent + '\t';

    for (const [key, value] of Array.from(map.entries())) {
        result += `${nextIndent}${key}: `;
        if (value instanceof Map) {
            result += mapToString(value, nextIndent);
        } else {
            result += `${JSON.stringify(value)},\n`;
        }
    }

    result += `${indent}}\n`;
    return result;
}


const convertToCbor = async (jsonString: string): Promise<string[]> => {
    try {
        // Parse the JSON string
        const json = JSON.parse(jsonString);

        // Create a face map and update the JSON object
        const faceMap = new Map<number, any>();
        faceMap.set(0, json.face.data);
        faceMap.set(1, 0);
        faceMap.set(2, 4);
        json['face'] = faceMap;

        console.log('DATA RECEIVED CONVERT: ', json);

        // Map the JSON data and encode it to CBOR
        const claim169MappedData = await getMappedData(json);
        return claim169MappedData;
    } catch (error) {
        console.error('Error parsing JSON string:', error);
        throw new Error('Invalid JSON string provided to convertToCbor');
    }
};

export default convertToCbor;